import { Component, Inject, LOCALE_ID, OnInit } from '@angular/core';
import { AbstractReportComponent } from '../abstract.report.component';
import { InventoryParameters, InventoryResult } from '../models/Inventory.interface';
import { DeviceDetectorService } from 'ngx-device-detector';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ReportService } from '../services/report.service';
import { FileService } from '../../shared/services/file.service';
import { AdminService } from '../../admin/services/admin.service';
import { ItemType } from '../../shared/models/item.type.interface';
import { RValue } from '../../shared/models/r.value.interface';
import { Vendor } from '../../shared/models/vendor.interface';
import { Warehouse } from '../../shared/models/warehouse.interface';
import { ItemUsage } from '../../shared/models/item.usage.interface';
import { InventoryParameterDialog } from './inventory-parameter/inventory-parameter.dialog';

@Component({
  selector: 'app-inventory',
  templateUrl: './inventory.component.html',
  styleUrl: './inventory.component.scss'
})
export class InventoryComponent extends AbstractReportComponent implements OnInit {
  itemTypes: ItemType[];
  itemTypesFiltered: ItemType[];
  rValues: RValue[];
  vendors: Vendor[];
  warehouses: Warehouse[];
  itemUsages: ItemUsage[] = [];
  itemType: ItemType;

  selectedItemTypes: string[] = [];
  selectedItemTypeString: string = '';

  selectedVendor: string = '';
  selectedWarehouse: string = '';
  selectedRValue: string = '';
  selectedStatus: string = '';




  report: InventoryResult[] = [];
  parameters: InventoryParameters = {
    itemSearch: null,
    statusId: null,
    itemTypeId: null,
    rValueId: null,
    vendorId: null,
    warehouseId: null,

    itemTypes: [],
    vendors: [],
    warehouses: [],
    rValues: []
  };

  constructor(@Inject(LOCALE_ID) locale: string,
    deviceDetectorService: DeviceDetectorService,
    dialog: MatDialog, private adminService: AdminService,
    private reportService: ReportService, private fileService: FileService) {
    super(locale, dialog, deviceDetectorService);
  }

  ngOnInit() {
    let dealerId = this.adminService.getDealerId();

    this.adminService.getItemTypes(dealerId)
      .subscribe({
        next: (data) => {
          this.itemTypes = data;
          this.parameters.itemTypes = data;
          if (this.parametersReady) { this.showParameters(); }
        }
      });
    this.adminService.getVendorsList(dealerId)
      .subscribe({
        next: (data) => {
          this.vendors = data;
          this.parameters.vendors = data;
          if (this.parametersReady) { this.showParameters(); }
        }
      });
    this.adminService.getWarehouseList(dealerId)
      .subscribe({
        next: (data) => {
          this.warehouses = data;
          this.parameters.warehouses = data;
          if (this.parametersReady) { this.showParameters(); }
        }
      });

    this.adminService.getrValues()
      .subscribe({
        next: (data) => {
          this.rValues = data;
          this.parameters.rValues = data;
          if (this.parametersReady) { this.showParameters(); }
        }
      });

    this.parameters.statusId = 1;

  }

  get parametersReady(): boolean {
    return this.vendors != undefined && this.warehouses != undefined && this.itemTypes != undefined && this.rValues != undefined;
  }


  filterItems() { }

  renderReport() {
    this.getReportFormat()
      .subscribe(formatData => {
        if (formatData == null) return;

        this.isRequesting = true;
        this.reportService.getInventoryReportExport(this.parameters, formatData.format, formatData.locale)
          .subscribe({
            next: (data) => {
              this.isRequesting = false;
              this.fileService.downloadFile(data, 'InventoryReport' + formatData.extension);
            },
            error: (error: string) => this.onError(error)
          });
      });
  }

  showParameters() {
    console.log(this.parameters);
    const dialogRef = this.dialog.open(InventoryParameterDialog, {
      width: '550px',
      data: this.parameters,
    }
    );

    dialogRef.afterClosed().subscribe((result: InventoryParameters) => {
      console.log('The dialog was closed');
      if (result) {
       this.selectedItemTypes = [];

        result.itemTypeId.forEach(sit => {
          const itemDesc = this.itemTypes.find(it => it.itemType_ID === sit)?.itemType_Desc;
          this.selectedItemTypes.push(itemDesc);
        });
        
        this.selectedRValue = result.rValueId !== null ? this.rValues.find(it => it.rValue_ID === result.rValueId).rValue_Desc : '';
        this.selectedVendor = result.vendorId !== null ? this.vendors.find(it => it.vendor_ID === result.vendorId).vendor_BusinessName : '';
        this.selectedWarehouse = result.warehouseId !== null ? this.warehouses.find(w => w.warehouse_ID === result.warehouseId).warehouse_Name : '';
        this.selectedStatus = result.statusId === 1 ? 'Active' : result.statusId === 0 ? 'Inactive' : 'All';

        this.selectedItemTypeString = this.selectedItemTypes.join(', ');

        this.parameters = result;
        //this.reportService.setupParameters(this.parameters);

        this.reportService.getInventoryReport(this.parameters)
          .subscribe({
            next: (data) => {
              this.report = data;
            },
            error: (error: string) => this.onError(error)
          });
      }
    });
  }
}
